<template>
	<router-view/>
</template>

<script>


export default {
	name: 'Agency'
}
</script>

<style lang="scss" scoped>
</style>




// WEBPACK FOOTER //
// src/views/agency/Agency.vue